import React, {Component} from 'react';
import Product from './Product';
import LoadingProducts from '../loaders/Products';
import Banner from './Banner';
import CSSTransitionGroup from 'react-addons-css-transition-group';

class Products extends Component {

    sortByKey = (array, key) => {
        return array.sort(function (a, b) {
            let x = a[key];
            let y = b[key];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
    };

    render() {
        let productsData;
        let productListNew = [].concat(this.sortByKey(this.props.productsList, 'orderIndex'));

        productsData = productListNew.map((product, key) => {
            //let obj = this.props.productsPrices;
            //let price = obj[Object.keys(obj).filter(key => (key === product.idProd))[0]];

            return (
                <Product
                    key={product.id}
                    price={product.price}
                    cartItems={this.props.cartItems}
                    name={product.name}
                    image={`products-img/${product.idProd}/${product.image}`}
                    id={product.id}
                    idProd={product.idProd}
                    available={product.available}
                    description={product.description}
                    descriptionEn={product.descriptionEn}
                    type={product.type}
                    addToCart={this.props.addToCart}
                    productQuantity={this.props.productQuantity}
                    updateQuantity={this.props.updateQuantity}
                    openModal={this.props.openModal}
                    locale={this.props.locale}
                />)
        });

        // Empty and Loading States
        let view;
        if (productsData.length <= 0) {
            view = <LoadingProducts/>
        } else {
            view = <CSSTransitionGroup
                transitionName="fadeIn"
                transitionEnterTimeout={500}
                transitionLeaveTimeout={300}
                component="div"
                className="products">
                <Banner subscribersDiscountInstance={this.props.subscribersDiscountInstance}
                        locale={this.props.locale}/>
                {productsData}
            </CSSTransitionGroup>
        }
        return (
            <div className="products-wrapper">{view}</div>
        )
    }
}

export default Products;


// WEBPACK FOOTER //
// ./src/components/Products.js